import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'

export default function Rebuild() {
  return (
    <PageLayout>
      <div className="book-page">
        <section>
          <h1>Rebuild Your Relationship With the LORD</h1>
          <p>Preventative measures to minimize the severity and frequency of temptations.</p>

            <blockquote>“Submit therefore to God. Resist the devil and he will flee from you.  Draw near to God and He will draw near to you. Cleanse your hands, you sinners; and purify your hearts, you double-minded.” <strong>(James 4:7-8)</strong> </blockquote>
        </section>
      </div>
    </PageLayout>
  );
};
